import {environment as defaultEnv} from "./environment.defaults";

export const environment = {
  ...defaultEnv,
};
